import React, { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

// import "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";


// import registerServiceWorker from "./serviceworker/registerServiceWorker";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import {  compose } from "redux";
import { Provider } from "react-redux";
import AppNavigation from "./navigation/AppNavigation";
import configureReduxStore from "./stores/index.js";

/**
 *
 *TODO:
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * Out of the box, the Redux store can only support the synchronous flow of data.
 * Using middleware like thunk helps support asynchronicity in a Redux application.
 * You can think of thunk as a wrapper for the store’s dispatch() method; rather than returning action objects,
 * we can use thunk action creators to dispatch functions or Promises.
 * Note that without thunks, synchronous dispatches are the default.
 */
// const store = configureReduxStore(
//   reducers,
//   composeEnhancers(applyMiddleware(apiMiddleware))
// );

// const root = hydrateRoot(document.getElementById("root"));

const router = createBrowserRouter(AppNavigation)

const store = configureReduxStore();
const root = createRoot(document.getElementById("root"));

root.render(
  // <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  // </StrictMode>
);

// registerServiceWorker();
